import { Grid } from "@mui/material";

export const RenderMessageWithIcon = (icon: React.ReactNode, message: string) => (
  <Grid container direction="row" alignItems="center" flexWrap="nowrap">
    <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
      {icon}
    </Grid>
    <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ fontSize: 12 }}>{message}</span>
    </Grid>
  </Grid>
);